import type { AppEnvType } from '../app-env';

export interface IAnalyticsVars {
  gtmId: string;
  ga4MeasurementId: string;
  ga4AdminMeasurementId: string;
  metaPixelId: string;
  tiktokPixelId: string;
  googleAdsConversionId: string;
  mixpanelToken: string;
  appsFlyerKey: string;
  posthogKey: string;
}

const gtmContainerId = 'GTM-56826N7R';

const emptyIds = {
  ga4MeasurementId: '',
  ga4AdminMeasurementId: '',
  metaPixelId: '',
  tiktokPixelId: '',
  googleAdsConversionId: '',
  mixpanelToken: '',
  appsFlyerKey: '',
  posthogKey: '',
};

export const analyticsVars: Record<AppEnvType, IAnalyticsVars> = {
  local: { gtmId: gtmContainerId, ...emptyIds },
  dev: { gtmId: gtmContainerId, ...emptyIds },
  stg: { gtmId: gtmContainerId, ...emptyIds },
  prod: { gtmId: gtmContainerId, ...emptyIds },
};
